export default __webpack_public_path__ + "src/images/packages/kosi-forest-lodge/e97158bf71c458657aafe419505c1b6e-5.jpg";